import { createSlice } from "@reduxjs/toolkit";
import { STATES_NAMES } from "../../enums/Enums";

const messagingInitialState = {
    currentScopeUsers: [],
    messagingHistoryToMailingLists: [],
    messagingCostsData: {},
    campaignsData: {
        deletedCampaigns: [],
        campaigns: [],
        minDate: null,
        maxDate: null
    },
    messagingHistoriesData: {
        messagingHistories: [],
        minDate: null,
        maxDate: null
    },
    mailingListsData: {
        mailingLists: [],
        minDate: null,
        maxDate: null
    },
    messagingSelectionModel: null
}

const messagingSlice = createSlice({
    name: STATES_NAMES.MESSAGING,
    initialState: messagingInitialState,
    reducers: {
        setCurrentScopeUsers(state, action) {
            state.currentScopeUsers = action.payload;
        },
        setMessagingHistoryToMailingLists(state, action) {
            state.messagingHistoryToMailingLists = action.payload;
        },
        setMessagingCostsData(state, action) {
            state.messagingCostsData = { ...state.messagingCostsData, ...action.payload };
        },
        setCampaignsData(state, action) {
            state.campaignsData = { ...state.campaignsData, ...action.payload };
        },
        setMessagingHistoriesData(state, action) {
            state.messagingHistoriesData = { ...state.messagingHistoriesData, ...action.payload };
        },
        setMailingListsData(state, action) {
            state.mailingListsData = { ...state.mailingListsData, ...action.payload };
        },
        setMessagingSelectionModel(state, action) {
            state.messagingSelectionModel = action.payload;
        }
    }
});

export const messagingActions = messagingSlice.actions;

export default messagingSlice.reducer;